import { ServerResponse } from "@model/commonModel"
import { http } from "@api/http"

export function getConfig(): Promise<ServerResponse<any>> {
  return http.get("/self/config")
}
